import { AbsoluteFill } from "remotion";
import { Video } from "@remotion/media";
import {
  CompositionTransitionCompositionProps,
  PREVIEW_CLIP_URL,
} from "../../CompositionTransitionComposition.tsx";
import CompositionTransitionWrapper from "../CompositionTransitionBuilder/CompositionTransitionWrapper.tsx";

export default function CompositionTransitionPreview({
  type,
  transition,
  clipDurationInFrames,
}: CompositionTransitionCompositionProps) {
  return (
    <CompositionTransitionWrapper
      startTransition={type === "START" ? transition : null}
      endTransition={type === "END" ? transition : null}
      durationInFrames={clipDurationInFrames}
    >
      <AbsoluteFill>
        <Video
          src={PREVIEW_CLIP_URL}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 1080,
            height: 1080,
          }}
        />
      </AbsoluteFill>
    </CompositionTransitionWrapper>
  );
}
